import { render, staticRenderFns } from "./staffManage.vue?vue&type=template&id=20b9851f&scoped=true&"
import script from "./staffManage.vue?vue&type=script&lang=js&"
export * from "./staffManage.vue?vue&type=script&lang=js&"
import style0 from "./staffManage.vue?vue&type=style&index=0&id=20b9851f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9851f",
  null
  
)

export default component.exports